import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import ReactHtmlParser from "react-html-parser";

import styled from "styled-components";

import Theme from "@airasia/phoenix-components/components/Theme";
import Title from "@airasia/phoenix-components/components/Title";
import Text from "@airasia/phoenix-components/components/Text";
import Image from "@airasia/phoenix-components/components/Image";
import Button from "@airasia/phoenix-components/components/button"

import "../css/main.css";
import "../styles/global.css";
import { fireGtmEvent, getGtmUserType } from "../utils/functions";


const TabContent = styled.div`
margin:0 auto;

#howtobook-image img{
width:30%;
}

@media only screen and (max-width: 720px) {
  #howtobook-image img{
    width:80%;
}
}
`

const MerchantWrapper = styled.div`
  width: 100%;
  margin: 3em auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align:center;


  @media only screen and (max-width: 400px) {
    width: 100%;
    gap: 10px;
  }
`;

const Merchant = styled.div`
  display: block;
  width:28%;
  margin:1em auto;
  text-align: center;
  background-color:#eb3223;
  border-radius:20px;
  padding:1em;

  #merchant-image, #howtobook-image  {
    background-color: transparent;
    margin:0em auto;
  }
  
  @media only screen and (max-width: 480px) {
    width:100%;
    margin-bottom: 2em;
    margin: 1em auto;

    #merchant-image, #howtobook-image  {
    width:100%;
  }

  }


`;

const TitleWrapperFlex = styled.div`
    margin:0 auto;
    

  #title {
    color: #fff;
    font-weight: 700;
    font-size: 1.2rem;
    margin:10px auto;
  }

  #subtitle{
      line-height:1.5rem;
      display:block;
}

  @media only screen and (max-width: 720px) {
    width: 90%;
    padding-left: 0em;
    padding-right: 0em;

    #title {
      font-size: 1.2rem;
    }
  }
`;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Theme theme="AIRASIA_CLASSIC">
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Theme theme="AIRASIA_CLASSIC">{children}</Theme>
          </Box>
        )}
      </div>
    </Theme>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Theme theme="AIRASIA_CLASSIC">
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange}>
            <Tab label="Independent Driver" {...a11yProps(0)} />
            <Tab label="Full-Time Driver" {...a11yProps(1)} />
            {/* <Tab label="Independent Rider" {...a11yProps(2)} /> */}
          </Tabs>
        </Box>
        <br />
        <TabPanel value={value} index={0}>
          <TabContent>
        <Image
                accessible
                customProperties={{
                  id: "howtobook-image"
                }}
                placeHolderBackground="none"
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite-airasia-independent-driver.png"
                alt="airasia independent driver"
              />
          <Title
            accessible
            inverted={false}
            textAlign="center"
            type="h2"
            color="primary"
          >
            airasia independent driver
          </Title>
          <Text
            accessible
            display="inlineFlex"
            hasToggle={false}
            opacity={1}
            tag="p"
            translation={{}}
            type="default"
          >
            Earn more with the freedom to choose your preferred ride requests. 
          </Text>
          
          </TabContent>

          <Button
                    accessible
                    buttonType="button"
                    boxShadow
                    customProperties={{
                      id: "ctaButton",
                      paddingBottom: "0.7rem",
                      paddingLeft: "3rem",
                      paddingRight: "3rem",
                      paddingTop: "0.7rem"
                    }}
                    size="normal"
                    color="primary"
                    backgroundColor="default"
                    handleClick={() => {
                      fireGtmEvent({
                        "event": 'trackEventNoEcommerce',
                        "eventDetails.category": "Ride | Request Here",
                        "eventDetails.action": "click",
                        "eventDetails.label": `independent driver | ${getGtmUserType()}`
                      })
                      window.open("https://forms.gle/j3zqzeWngf1Bp69G8 ")
                    }}
                  >
                    Join as Independent Driver
                  </Button>

          <MerchantWrapper>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_requirement.png"
                alt="Requirements"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Requirements
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  <ul>
                    <li>Own a 4-wheeler vehicle that is not older than 10 years. </li>
                    <li>Vehicle must be inspected and approved by Puspakom. </li>
                    <li>Vehicle must be suitable to transport passengers. </li>
                    <li>Agreeable to all terms and conditions set by airasia ride, including a 15% commission payable to airasia. </li>
                  </ul>
                </Text>
              </TitleWrapperFlex>
              
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_benefits.png"
                alt="Perks & Benefits"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Perks & Benefits
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  For airasia independent drivers, you stand to earn:
                  <ol>
                      <li>Earn up to RM400 every day. </li>
                      <li>Earn extra incentives up to RM600 weekly.  </li>
                      <li>90% OFF AirAsia flights as Captain Rank Drivers, subject to performance. </li>
                      <li>Earn faster with zero queues on all airport trips. </li>
                      <li>Weekly payout.  </li>
                  </ol>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_register.png"
                alt={props.Tab1title3}
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Registration Process
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  color="default"
                  type="p"
                  customProperties={{ id: "subtitle" }}
                >
                  Be an Independent Driver by: 
                  <br />
                  <ol>
                    <li>Submitting your application at link below.</li>
                    <li>Uploading your documents via the airasia Driver app. </li>
                  </ol>
                  * Successful applicants will receive a notification on airasia Driver app.  
                  <br />
                  * If details are incomplete or inaccurate, applicants will receive a notification via SMS.
                  <br />* Registration status can be tracked on the app. 
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            
          </MerchantWrapper>
        </TabPanel>
        <TabPanel value={value} index={1}>
        <TabContent>
          <Image
                  accessible
                  placeHolderBackground="none"
                  customProperties={{
                    id: "howtobook-image",
                  }}
                  src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite-airasia-full-time-driver.png"
                  alt="airasia full-time driver"
                />
          <Title
            accessible
            inverted={false}
            textAlign="center"
            type="h2"
            color="primary"
          >
            airasia full-time driver
          </Title>
          <Text
            accessible
            display="inlineFlex"
            hasToggle={false}
            opacity={1}
            tag="p"
            translation={{}}
            type="default"
          >
            Earn up to RM8,000 monthly with great employment benefits.
          </Text>
          
          </TabContent>

          <Button
                    accessible
                    buttonType="button"
                    boxShadow
                    customProperties={{
                      id: "ctaButton",
                      paddingBottom: "0.7rem",
                      paddingLeft: "3rem",
                      paddingRight: "3rem",
                      paddingTop: "0.7rem"
                    }}
                    size="normal"
                    color="primary"
                    backgroundColor="default"
                    handleClick={() => {
                      fireGtmEvent({
                        "event": 'trackEventNoEcommerce',
                        "eventDetails.category": "Ride | Request Here",
                        "eventDetails.action": "click",
                        "eventDetails.label": `fultime driver | ${getGtmUserType()}`
                      })
                      window.open("https://forms.gle/j3zqzeWngf1Bp69G8 ")
                    }}
                  >
                    Join as Full-Time Driver  
                  </Button>

          <MerchantWrapper>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_requirement.png"
                alt="Requirements"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Requirements
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  If you own a car:
                  <ul>
                    <li>Own a 4-wheeler vehicle that is not older than 10 years. </li>
                    <li>Vehicle must be inspected and approved by Puspakom. </li>
                    <li>Vehicle must be suitable to transport passengers. </li>
                    <li>Agreeable to all terms and conditions set by airasia ride, including a 15% commission payable to airasia. </li>
                  </ul>
                  <br/>
                  * If you do not own a car, airasia ride will arrange for a rental with a lower monthly rate for you. 
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_benefits.png"
                alt="Perks & Benefits"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Perks & Benefits
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  <ul>
                    <li>Guaranteed income from RM3,500 monthly. </li>
                    <li>Additional incentives up to RM4,000.  </li>
                    <li>Lower car rental rates. </li>
                    <li>Guaranteed Captain Rank. </li>
                    <li>Public Service Vehicle (PSV) training and exam fees waived. </li>
                    <li>SOCSO, EPF and medical benefits. </li>
                    <li>90% OFF AirAsia flights, Annual Leave, Maternity & Paternity Leave, subject to performance. </li>
                    <li>Access to RedQ and Red Station headquarters. </li>
                    <li>Career advancements. </li>
                    <li>Weekly payout. </li>
                  </ul>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_register.png"
                alt={props.Tab1title3}
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Registration Process
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  color="default"
                  type="p"
                  customProperties={{ id: "subtitle" }}
                >
                  Be a Full-Time Driver by: 
                  <ol>
                    <li>Submitting your application at link below.</li>
                    <li>Uploading your documents via the airasia Driver app. </li>
                  </ol>
                  <br/>
                  * Successful applicants will receive a notification on airasia Driver app. 
                  <br/><br/>
                  * If details are incomplete or inaccurate, applicants will receive a notification via SMS.
                  <br/><br/>
                  * Registration status can be tracked on the app. 

                </Text>
              </TitleWrapperFlex>
            </Merchant>
            
          </MerchantWrapper>
        </TabPanel>
        {/* <TabPanel value={value} index={2}>
        <TabContent>
          <Image
                  accessible
                  placeHolderBackground="none"
                  customProperties={{
                    id: "howtobook-image",
                  }}
                  src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite-airasia-independent-rider.png"
                  alt="airasia independent rider"
                />
          <Title
            accessible
            inverted={false}
            textAlign="center"
            type="h2"
            color="primary"
          >
            airasia independent rider
          </Title>
          <Text
            accessible
            display="inlineFlex"
            hasToggle={false}
            opacity={1}
            tag="p"
            translation={{}}
            type="default"
          >
            Earn up to RM1,000 weekly, at your own pace. 
          </Text>
          </TabContent>

          <Button
                    accessible
                    buttonType="button"
                    boxShadow
                    customProperties={{
                      id: "ctaButton",
                      paddingBottom: "0.7rem",
                      paddingLeft: "3rem",
                      paddingRight: "3rem",
                      paddingTop: "0.7rem"
                    }}
                    size="normal"
                    color="primary"
                    backgroundColor="default"
                    handleClick={() => {
                      fireGtmEvent({
                        "event": 'trackEventNoEcommerce',
                        "eventDetails.category": "Ride | Request Here",
                        "eventDetails.action": "click",
                        "eventDetails.label": `independent rider | ${getGtmUserType()}`
                      })
                      window.open("https://docs.google.com/forms/d/e/1FAIpQLSdnlFeRuXnn8JxOyP1yMmtxOFzjA5-P-c5oGejxw_-1Q3SFMA/viewform?fbclid=IwAR1ZQW4GUiJBBFR32Yn-TEItNCm4ylMcIon6ztmKQUjzp-2KX1kzMHo8m5o")
                    }}
                  >
                    Join as Independent Rider 
                  </Button>

          <MerchantWrapper>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_requirement.png"
                alt="Requirements"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Requirements
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  You can be an Independent Rider if you: 
                  <ul>
                  <li>Own a motorcycle</li>
                  <li>Own a valid Malaysian motorcycle license. </li>
                  </ul>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_benefits.png"
                alt="Perks & Benefits"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Perks & Benefits
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  <ol>
                    <li>Earn up to RM1,000 weekly. </li>
                    <li>100% profit with zero commission fee. </li>
                    <li>90% OFF AirAsia flights. </li>
                    <li>Phone repair and food allowance provided. </li>
                    <li>Accident insurance coverage up to RM50,000. </li>
                    <li>Medical insurance coverage up to RM35,000. </li>
                  </ol>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_register.png"
                alt={props.Tab1title3}
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Registration Process
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  color="default"
                  type="p"
                  customProperties={{ id: "subtitle" }}
                >
                  Be an Independent Rider by: 
                  <br />
                  <ol>
                    <li>Submitting your application at link below.</li>
                    <li>Uploading your documents via the airasia Driver app. </li>
                  </ol>
                  * Successful applicants will receive a notification on airasia Driver app. 
                  <br />
                  * If details are incomplete or inaccurate, applicants will receive a notification via SMS.
                  <br />* Registration status can be tracked on the app.
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            
          </MerchantWrapper>
        </TabPanel> */}
        
      </Box>
    </Theme>
  );
}
